var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19132 11.9999C11.3427 11.9999 13.9056 9.43701 13.9056 6.28558C13.9056 3.13415 11.3427 0.571289 8.19132 0.571289C5.03989 0.571289 2.47703 3.13415 2.47703 6.28558C2.47703 9.43701 5.03989 11.9999 8.19132 11.9999ZM8.19132 2.47605C10.2923 2.47605 12.0008 4.18462 12.0008 6.28558C12.0008 8.38653 10.2923 10.0951 8.19132 10.0951C6.09036 10.0951 4.38179 8.38653 4.38179 6.28558C4.38179 4.18462 6.09036 2.47605 8.19132 2.47605ZM5.33417 13.9046H10.0961V15.8094H5.33417C3.75893 15.8094 2.47703 17.0913 2.47703 18.6665V23.4284H0.572266V18.6665C0.572266 16.0408 2.70846 13.9046 5.33417 13.9046ZM21.5247 13.9046C21.5247 11.8037 19.8161 10.0951 17.7151 10.0951C15.6142 10.0951 13.9056 11.8037 13.9056 13.9046H12.0008V20.5713C12.0008 22.1465 13.2828 23.4284 14.858 23.4284H20.5723C22.1475 23.4284 23.4294 22.1465 23.4294 20.5713V13.9046H21.5247ZM17.7151 11.9999C18.7656 11.9999 19.6199 12.8542 19.6199 13.9046H15.8104C15.8104 12.8542 16.6647 11.9999 17.7151 11.9999ZM21.5247 20.5713C21.5247 21.0961 21.097 21.5237 20.5723 21.5237H14.858C14.3332 21.5237 13.9056 21.0961 13.9056 20.5713V15.8094H21.5247V20.5713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customers-icon.caabbde7b5443a56ecc2a0ab99469c95.svg";
export { ForwardRef as ReactComponent };